var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg12PxCaretRight = function Svg12PxCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.479 4.752 4.832 1.653a1.5 1.5 0 0 0-1.54-.074A1.5 1.5 0 0 0 2.5 2.901v6.197a1.5 1.5 0 0 0 1.5 1.5c.291 0 .581-.085.832-.252l4.647-3.099a1.5 1.5 0 0 0 0-2.496Z"
  })));
};
export default Svg12PxCaretRight;